/* Garazha — UI behaviour. No framework, no build step.
   Everything here is progressive: the page works without it. */
(function (w, d) {
  'use strict';

  /* ---------- drawers ---------- */
  function openDrawer(id) {
    var el = d.getElementById(id); if (!el) return;
    el.classList.add('is-open'); d.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('button,a,select,input'); if (f) f.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open'); d.documentElement.style.overflow = '';
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drw__scrim')) {
      closeDrawer(e.target.closest('.drw'));
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var o = d.querySelector('.drw.is-open'); if (o) closeDrawer(o); }
  });

  /* ---------- hero video: never block, never waste a mobile plan ---------- */
  function heroVideo() {
    var v = d.querySelector('[data-hero-video]'); if (!v) return;
    var c = navigator.connection || {};
    var skip = matchMedia('(prefers-reduced-motion: reduce)').matches
            || c.saveData === true || /(^|-)2g/.test(c.effectiveType || '');
    if (skip) return;
    var srcs = (v.getAttribute('data-sources') || '').split('|').filter(Boolean);
    srcs.forEach(function (pair) {
      var i = pair.indexOf('::'); if (i < 0) return;
      var s = d.createElement('source');
      s.type = pair.slice(0, i); s.src = pair.slice(i + 2);
      v.appendChild(s);
    });
    v.load();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  /* ---------- product gallery ---------- */
  function gallery() {
    var g = d.querySelector('[data-gallery]'); if (!g) return;
    var main = g.querySelector('[data-gallery-main]');
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gallery-thumb]'); if (!b || !main) return;
      main.src = b.getAttribute('data-src');
      main.srcset = b.getAttribute('data-srcset') || '';
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === b ? 'true' : 'false');
      });
    });
  }

  /* ---------- variant picker ---------- */
  function variants() {
    var form = d.querySelector('form[action$="/cart/add"]'); if (!form) return;
    var data = null;
    try { data = JSON.parse(d.getElementById('VariantData').textContent); } catch (e) { return; }
    var idField = form.querySelector('[name="id"]');
    var priceEl = d.querySelector('[data-price-now]');
    var wasEl = d.querySelector('[data-price-was]');
    var btn = form.querySelector('[data-add]');
    var stock = d.querySelector('[data-stock]');

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-opt]:checked'), function (i) { return i.value; });
    }
    function update() {
      /* Produkti me një variant të vetëm nuk ka fare butona opsionesh; atëherë
         varianti është i pari dhe pika. Më parë këtu dilte "nuk u gjet varianti"
         dhe butoni i blerjes çaktivizohej pa asnjë arsye. Blerja nuk varet
         kurrë nga makina e zgjedhur — përshtatjen e themi, nuk e ndalojmë. */
      var opts = form.querySelectorAll('[data-opt]');
      var sel = selected();
      var v = null;
      if (!opts.length) {
        v = data[0];
      } else {
        v = data.find(function (x) {
          return x.options.length === sel.length && x.options.every(function (o, i) { return o === sel[i]; });
        });
      }
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (wasEl) { wasEl.textContent = v.compare || ''; wasEl.classList.toggle('hide', !v.compare); }
      if (btn) {
        btn.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        btn.textContent = btn.getAttribute(v.available ? 'data-label-available' : 'data-label-sold');
      }
      if (stock) stock.textContent = v.stockLabel || '';
      if (w.history.replaceState) {
        var u = new URL(w.location.href); u.searchParams.set('variant', v.id);
        w.history.replaceState({}, '', u);
      }
    }
    form.addEventListener('change', function (e) { if (e.target.matches('[data-opt]')) update(); });
    update();
  }


  /* ---------- lyerja sipas ngjyrës ----------
     The customer is told exactly where the sticker is. If they can't find it,
     the photos plus a callback are the fallback — so photos are required
     whenever paint is requested, never optional. */
  function paint() {
    var box = d.querySelector('[data-paint]'); if (!box) return;
    var form = box.closest('form'); if (!form) return;
    var want = box.querySelector('[data-paint-want]');
    var fields = box.querySelector('[data-paint-fields]');
    var ups = box.querySelector('[data-paint-uploads]');
    var err = box.querySelector('[data-paint-error]');
    var ack = box.querySelector('[data-paint-ack]');
    var ackErr = box.querySelector('[data-paint-ack-error]');
    var min = parseInt(ups && ups.getAttribute('data-min'), 10) || 3;

    function sync() {
      var on = want && want.checked;
      if (fields) fields.hidden = !on;
      if (on && !box.open) box.open = true;
    }
    sync();
    if (want) want.addEventListener('change', sync);

    box.addEventListener('change', function (e) {
      var f = e.target.closest('[data-paint-file]');
      if (!f) return;
      var wrap = f.closest('.up');
      if (wrap) wrap.setAttribute('data-filled', f.files && f.files.length ? 'true' : 'false');
      if (err) err.classList.add('hide');
    });
    if (ack) ack.addEventListener('change', function () {
      if (ackErr && ack.checked) ackErr.classList.add('hide');
    });

    /* finish picker swaps a precomputed figure — no arithmetic in the browser */
    var pbox = box.querySelector('[data-paint-price]');
    if (pbox) box.addEventListener('change', function (e) {
      var r = e.target.closest('[data-paint-finish]'); if (!r) return;
      var amt = pbox.querySelector('[data-paint-amount]');
      var v = pbox.getAttribute('data-' + r.getAttribute('data-key'));
      if (amt && v) amt.textContent = v;
    });

    form.addEventListener('submit', function (e) {
      var stripped = [];
      if (want && want.checked) {
        var files = box.querySelectorAll('[data-paint-file]'), n = 0;
        for (var i = 0; i < files.length; i++) if (files[i].files && files[i].files.length) n++;
        if (n < min) {
          e.preventDefault();
          if (err) { err.classList.remove('hide'); err.scrollIntoView({ block: 'center' }); }
          return;
        }
        /* a painted part cannot come back — the customer says so in their own click */
        if (ack && !ack.checked) {
          e.preventDefault();
          if (ackErr) { ackErr.classList.remove('hide'); ackErr.scrollIntoView({ block: 'center' }); }
          return;
        }
      }
      /* never send empty properties to the order */
      var all = box.querySelectorAll('input[name^="properties["]');
      for (var j = 0; j < all.length; j++) {
        var el = all[j], empty =
          el.type === 'file' ? !(el.files && el.files.length) :
          el.type === 'checkbox' ? !el.checked :
          el.value.trim() === '';
        if (empty || (want && !want.checked)) { el.disabled = true; stripped.push(el); }
      }
      setTimeout(function () {
        for (var k = 0; k < stripped.length; k++) stripped[k].disabled = false;
      }, 0);
    });
  }

  /* suggestion chips fill the box instead of firing a hidden query —
     the customer sees what they are about to ask */
  /* Pasi ruhet makina, sirtari nuk mbyllet në heshtje: e konfirmon dhe jep
     rrugën e vetme që i duhet klientit tani — pjesët për atë veturë. */
  function garageConfirm() {
    var drw = d.getElementById('GarageDrawer');
    if (!drw || !w.Garage) return;
    var body = drw.querySelector('.drw__body');
    if (!body) return;
    var box = d.createElement('div');
    box.className = 'garconf';
    box.hidden = true;
    box.innerHTML = '<p class="garconf__t"></p><a class="btn btn--primary btn--wide garconf__go"></a>';
    body.insertBefore(box, body.firstChild);
    var t = box.querySelector('.garconf__t'), go = box.querySelector('.garconf__go');

    d.addEventListener('garage:change', function () {
      var car = w.Garage.get(), q = w.Garage.query(car);
      if (!q) { box.hidden = true; return; }
      t.textContent = (drw.getAttribute('data-saved') || 'U ruajt') + ': ' + w.Garage.label(car);
      go.textContent = (drw.getAttribute('data-see') || 'Shiko pjesët për') + ' ' + q;
      go.href = '/search?type=product&q=' + encodeURIComponent(q);
      box.hidden = false;
    });
  }

  /* ---------- çka po thotë klienti ----------
     Njeriu nuk shkruan si makinë kërkimi. Shkruan "kam nje Golf 7 2017, me duhet
     parakolpi". Nëse atë fjali ia japim kërkimit ashtu siç është, Shopify i ndan
     fjalët dhe kthen çdo gjë që ka një "7" ose një "2017" — pra pleh.
     Prandaj e lexojmë fjalinë vetë: nxjerrim markën, modelin, gjeneratën, vitin dhe
     llojin e pjesës nga të njëjtat tabela që përdor gjithë faqja, dhe kërkojmë
     VETËM me ato. Nëse s'kuptojmë asgjë, e lëmë fjalinë siç është — më mirë
     kërkim i dobët sesa kërkim i shpikur. */
  /* Fjalori i pjesëve rri te words.js, që ta përditësojmë pa e prekur këtë skedar. */
  var W_ = w.BAJRAMI_WORDS || {};
  var PART_WORDS = W_.parts || [];
  var UNIVERSAL  = W_.universal || [];
  var NOT_OURS   = W_.notOurs || [];

  var WORD_NUM = [['seven point five', '7.5'], ['seven', '7'], ['eight', '8'],
                  ['six', '6'], ['five', '5'], ['four', '4'],
                  ['shtat', '7'], ['tet', '8'], ['gjasht', '6'], ['pes', '5']];

  /* Markat që nuk i mbajmë. Nëse klienti e emërton njërën, nuk guxojmë ta
     hamendësojmë një model nga një kod i vetëm — "C7 për Hondën time" nuk është Audi A7. */
  var FOREIGN = ['honda','toyota','ford','skoda','škoda','opel','peugeot','renault','fiat',
                 'nissan','mazda','hyundai','kia','seat','volvo','dacia','citroen','citroën',
                 'jaguar','tesla','chevrolet','suzuki','lancia','alfa','mitsubishi','subaru'];

  function esc(x) { return x.replace(/[.*+?^${}()|[\]\\]/g, function (m) { return '\\' + m; }); }
  /* Fjalë e plotë, jo copë fjale: ndryshe "TT" gjendet brenda "spliTTer",
     "CR" brenda "sCRipt" dhe "8V" brenda "8V80". */
  function has(q, tok) {
    return new RegExp('(^|[^a-z0-9.])' + esc(tok.toLowerCase()) + '($|[^a-z0-9.])').test(q);
  }

  var ALIAS = W_.alias || [];
  var RULES = [];
  (function () {
    var rs = W_.rules || [];
    for (var i = 0; i < rs.length; i++) {
      try { RULES.push([new RegExp(rs[i][0], rs[i][1]), rs[i][2]]); } catch (e) {}
    }
  })();

  var ALIAS_MAP = {};
  var ALIAS_RE = (function () {
    var keys = [];
    for (var i = 0; i < ALIAS.length; i++) {
      ALIAS_MAP[ALIAS[i][0]] = ALIAS[i][1];
      keys.push(ALIAS[i][0]);
    }
    if (!keys.length) return /(?!)/;      /* pa fjalor: mos zëvendëso asgjë */
    keys.sort(function (a, b) { return b.length - a.length; });
    var esc2 = function (x) { return x.replace(/[.*+?^${}()|[\]\\]/g, function (m) { return '\\' + m; }); };
    return new RegExp('(^|[^a-z0-9.])(' + keys.map(esc2).join('|') + ')($|[^a-z0-9.])', 'g');
  })();

  function readCar(text) {
    var q = String(text || '').toLowerCase();
    /* Pastrimi i shkrimit vjen i pari: prapashtesat shqipe dhe gabimet e shtypit. */
    for (var ri = 0; ri < RULES.length; ri++) q = q.replace(RULES[ri][0], RULES[ri][1]);
    /* Një kalim i vetëm mbi të gjitha shkurtesat. Me zëvendësime të njëpasnjëshme
       teksti i sapo-zëvendësuar do të zëvendësohej sërish: "gle" bëhet "gle-class",
       pastaj "cla" brenda tij bëhet "cla-class" dhe fjala shkatërrohet. */
    q = (' ' + q + ' ').replace(ALIAS_RE, function (all, pre, hit, post) {
      return pre + (ALIAS_MAP[hit] || hit) + post;
    });
    for (var wi = 0; wi < WORD_NUM.length; wi++) {
      q = q.split(WORD_NUM[wi][0]).join(WORD_NUM[wi][1]);
    }
    q = ' ' + q + ' ';
    /* Kur BMW-ja është thënë, një shifër e vetme është seria: "bmw 1 2015".
       Pa BMW-në nuk e bëjmë — një "3" i vetëm mund të jetë çfarëdo. */
    if (/(^|[^a-z0-9])bmw($|[^a-z0-9])/.test(q)) {
      q = q.replace(/(^|[^a-z0-9])([1-8])($|[^a-z0-9])/g,
                    function (a, pre, n, post) { return pre + n + ' series' + post; });
    }
    /* Emrat e motorit dhe të paketave: njerëzit shkruajnë 330i, C63, RS6, SQ7 —
       jo "3 Series", "C-Class", "A6", "Q7". I përkthejmë para se të lexojmë. */
    /* Shkronja e motorit është e detyrueshme: 330i, 520d, M340i, 330e.
       Pa të, "150 copë" ose "€100" do të lexoheshin si BMW 1 Series. */
    q = q.replace(/(^|[^a-z0-9])m?([1-8])[0-9]{2}\s?([dixe])([^a-z0-9]|$)/g,
                  function (a, pre, n, l, post) { return pre + n + ' series' + post; });
    q = q.replace(/(^|[^a-z0-9])(cla|cls|gla|glb|glc|gle|gls|[abcesg])\s?(4[35]|5[03]|63)([^a-z0-9]|$)/g,
                  function (a, pre, cl, n, post) { return pre + cl + '-class' + post; });
    q = q.replace(/(^|[^a-z0-9])r?s([1-8])([^a-z0-9]|$)/g,
                  function (a, pre, n, post) { return pre + 'a' + n + post; });
    q = q.replace(/(^|[^a-z0-9])r?s\s?q([2-8])([^a-z0-9]|$)/g,
                  function (a, pre, n, post) { return pre + 'q' + n + post; });

    var out = { model: '', gen: '', part: '', year: 0, brand: '', ambiguous: false };
    if (!q.trim() || !w.BAJRAMI_FIT) return out;

    var foreign = false;
    for (var fi = 0; fi < FOREIGN.length; fi++) {
      if (has(q, FOREIGN[fi])) { foreign = true; break; }
    }

    /* Sa modele përmenden? Dy modele = dy vetura; atëherë nuk zgjedhim ne. */
    var found = [];
    for (var brand in w.BAJRAMI_FIT) {
      var models = w.BAJRAMI_FIT[brand];
      for (var model in models) {
        if (has(q, model)) found.push({ brand: brand, model: model });
      }
    }
    if (found.length === 1) {
      out.brand = found[0].brand; out.model = found[0].model;
    } else if (found.length > 1) {
      out.ambiguous = true;
      return out;
    }

    if (out.model) {
      var gens = w.BAJRAMI_FIT[out.brand][out.model];
      var hits = [];
      for (var i = 0; i < gens.length; i++) {
        var g = gens[i].g;
        if (!g) continue;
        var base = g.replace(' Facelift', '');
        if (has(q, base) && hits.indexOf(base) < 0) hits.push(base);
      }
      /* "Golf 7 nga Golf 7.5", "B8 ne B9", "F30 to G20" — konvertim.
         Vetura që e ka klienti është E PARA; atë mbajmë. */
      if (hits.length > 1) {
        var first = hits[0], at = q.length;
        for (var hi = 0; hi < hits.length; hi++) {
          var pos = q.indexOf(hits[hi].toLowerCase());
          if (pos > -1 && pos < at) { at = pos; first = hits[hi]; }
        }
        out.gen = first;
      } else if (hits.length === 1) {
        out.gen = hits[0];
      }
      /* Facelift / LCI e ndan gjeneratën; e shtojmë vetëm nëse ajo ndarje ekziston. */
      if (out.gen && (q.indexOf('facelift') > -1 || has(q, 'lci'))) {
        for (var fx = 0; fx < gens.length; fx++) {
          if (gens[fx].g === out.gen + ' Facelift') { out.gen = out.gen + ' Facelift'; break; }
        }
      }
    } else if (!foreign) {
      /* Vetëm kodi, pa model: "W205 facelift", "G20", "B9". */
      var cands = [];
      for (var b2 in w.BAJRAMI_FIT) {
        var ms = w.BAJRAMI_FIT[b2];
        for (var m2 in ms) {
          var gl = ms[m2];
          for (var gi = 0; gi < gl.length; gi++) {
            var gg = gl[gi].g;
            if (!gg || gg.length < 2) continue;
            var bb = gg.replace(' Facelift', '');
            if (has(q, bb)) cands.push({ b: b2, m: m2, g: bb });
          }
        }
      }
      var uniq = [];
      for (var ci = 0; ci < cands.length; ci++) {
        var key = cands[ci].m + '|' + cands[ci].g;
        if (uniq.indexOf(key) < 0) uniq.push(key);
      }
      if (uniq.length === 1) {
        out.brand = cands[0].b; out.model = cands[0].m; out.gen = cands[0].g;
        if (q.indexOf('facelift') > -1 || has(q, 'lci')) {
          var gl2 = w.BAJRAMI_FIT[out.brand][out.model];
          for (var fy = 0; fy < gl2.length; fy++) {
            if (gl2[fy].g === out.gen + ' Facelift') { out.gen = out.gen + ' Facelift'; break; }
          }
        }
      } else if (uniq.length > 1) {
        out.ambiguous = true;
      }
    }

    for (var yi = 0; yi + 4 <= q.length; yi++) {
      var chunk = q.substr(yi, 4);
      if (/^(19|20)[0-9][0-9]$/.test(chunk)) { out.year = parseInt(chunk, 10); break; }
    }
    for (var pi = 0; pi < PART_WORDS.length; pi++) {
      if (q.indexOf(PART_WORDS[pi][0]) > -1) { out.part = PART_WORDS[pi][1]; break; }
    }
    /* Pjesët e karrocerisë kanë përparësi: "kapak motori" është haubë, jo motor. */
    if (!out.part) {
      for (var ui = 0; ui < UNIVERSAL.length; ui++) {
        if (q.indexOf(UNIVERSAL[ui][0]) > -1) { out.universal = UNIVERSAL[ui][1]; break; }
      }
    }
    if (!out.part && !out.universal) {
      for (var ni = 0; ni < NOT_OURS.length; ni++) {
        if (q.indexOf(NOT_OURS[ni][0]) < 0) continue;
        /* "Cayenne Turbo" është emër modeli, jo turbina. */
        if (NOT_OURS[ni][0] === 'turbo' && out.model === 'Cayenne') continue;
        out.notOurs = NOT_OURS[ni][1]; break;
      }
    }
    if (out.part === 'bumper') {
      if (q.indexOf('mbrapa') > -1 || q.indexOf('prapa') > -1 || q.indexOf('rear') > -1) {
        out.part = 'rear bumper';
      } else if (q.indexOf('para') > -1 || q.indexOf('front') > -1) {
        out.part = 'front bumper';
      }
    }
    return out;
  }

  /* Fjalët me të cilat ia vlen ta pyesim dyqanin. */
  function cleanQuery(text) {
    var c = readCar(text);
    /* Bateri, llamba, kimikate: kërkohet vetëm produkti — modeli s'është në titull. */
    if (c.universal) return c.universal;
    if (!c.model) return '';
    var bits = [c.model];
    if (c.gen) bits = c.gen.indexOf(c.model) === 0 ? [c.gen] : [c.model, c.gen];
    if (c.part) bits.push(c.part);
    return bits.join(' ');
  }

  function baci() {
    var f = d.querySelector('.baci__form'); if (!f) return;
    var i = f.querySelector('input[name="q"]');
    d.addEventListener('click', function (e) {
      var c = e.target.closest('[data-baci-fill]'); if (!c || !i) return;
      i.value = c.getAttribute('data-baci-fill');
      i.focus();
    });

    /* Para se ta dërgojmë, e përkthejmë fjalinë në fjalët që dyqani i njeh.
       Fjalia origjinale shkon bashkë me të, që faqja e rezultateve ta tregojë
       se çka kuptuam — klienti duhet ta shohë, jo ta hamendësojë. */
    f.addEventListener('submit', function (e) {
      if (!i || !i.value) return;
      var said = i.value;
      var clean = cleanQuery(said);
      var nope = readCar(said).notOurs || '';
      if (!clean && !nope) return;
      if (!clean) clean = said;                 /* s'e shesim dhe s'ka veturë: le të dalë bosh */
      if (clean.toLowerCase() === said.trim().toLowerCase() && !nope) return;
      e.preventDefault();
      w.location.href = f.getAttribute('action') + '?type=product&q=' +
        encodeURIComponent(clean) + '&said=' + encodeURIComponent(said) +
        (nope ? '&nope=' + encodeURIComponent(nope) : '');
    });
  }

  /* filtrat: ndryshimi e dërgon formën vetë — pa buton "zbato" në desktop.
     Pa JS mbetet <noscript> butoni, pra forma është ende e përdorshme. */
  function facets() {
    var forms = d.querySelectorAll('.facets'); if (!forms.length) return;
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('change', function (e) {
        if (e.target.matches('[data-fit-only]')) return;
        if (e.target.type === 'number') return;
        var u = new URL(w.location.href);
        u.searchParams.delete('page');
        var keep = new URLSearchParams();
        u.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') !== 0) keep.append(k, v); });
        var f = e.target.form;
        f.querySelectorAll('input[type="checkbox"][name^="filter."]:checked').forEach(function (c) {
          keep.append(c.name, c.value);
        });
        w.location.href = u.pathname + '?' + keep.toString();
      });
    }
  }

  /* "vetëm çka i përshtatet" filtron atë që është në faqe, dhe e thotë ashtu.
     Nuk pretendon të jetë filtër serveri — numri i faqes nuk ndryshon. */
  function fitOnly() {
    var boxes = d.querySelectorAll('[data-fit-only]'); if (!boxes.length) return;
    function apply(on) {
      var cards = d.querySelectorAll('.grid .card');
      var shown = 0;
      for (var i = 0; i < cards.length; i++) {
        var chip = cards[i].querySelector('[data-fit]');
        var st = chip ? chip.getAttribute('data-state') : 'unknown';
        var hide = on && st !== 'fit';
        cards[i].hidden = hide;
        if (!hide) shown++;
      }
      var c = d.querySelector('[data-count]');
      if (c) c.setAttribute('data-shown', shown);
      for (var j = 0; j < boxes.length; j++) boxes[j].checked = on;
    }
    for (var k = 0; k < boxes.length; k++) {
      boxes[k].addEventListener('change', function (e) { apply(e.target.checked); });
    }
    d.addEventListener('garage:change', function () {
      if (boxes[0].checked) setTimeout(function () { apply(true); }, 0);
    });
  }

  /* shto pa e lëshuar faqen. Pa JS forma bën POST normal dhe çon te shporta,
     prandaj asgjë nuk humbet nëse skripti dështon. */
  function quickAdd() {
    d.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-quick-add]'); if (!f) return;
      if (!w.fetch) return;
      e.preventDefault();
      var btn = f.querySelector('.qadd__btn'), span = btn.querySelector('span');
      var done = btn.getAttribute('data-done'), label = btn.getAttribute('data-label');
      btn.disabled = true;
      fetch(f.action + '.js', { method: 'POST', body: new FormData(f),
        headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (span) span.textContent = done;
          btn.classList.add('is-done');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = d.querySelector('.icobtn .count');
          if (c) { c.textContent = cart.item_count; }
          else {
            var link = d.querySelector('a.icobtn[href*="cart"]');
            if (link) {
              var s2 = d.createElement('span'); s2.className = 'count';
              s2.textContent = cart.item_count; link.appendChild(s2);
            }
          }
        })
        .catch(function () { f.submit(); })
        .then(function () {
          setTimeout(function () {
            btn.disabled = false; btn.classList.remove('is-done');
            if (span) span.textContent = label;
          }, 2200);
        });
    });
  }


  /* ---------- "Të tjera për <makina>" ----------
     Sugjerimi duhet të jetë për të njëjtën veturë dhe për pjesë tjetër.
     Prandaj marrim rezultatet e kërkimit për gjeneratën e kësaj veture, i filtrojmë
     me identitetin që mbart çdo kartë, dhe përpara vëmë llojet e ndryshme nga kjo pjesë.
     Nëse nuk mbetet asgjë e sigurt, seksioni thjesht nuk shfaqet — më mirë asgjë
     sesa një grill Audi te një Golf. */
  function related() {
    var host = d.querySelector('[data-related]');
    if (!host || !w.Garage) return;
    var grid = host.querySelector('[data-related-grid]');
    var me = host.getAttribute('data-id');
    var self = w.Garage.parseFit(host.getAttribute('data-car'));
    var url = '/search?type=product&view=related&q=' + encodeURIComponent(host.getAttribute('data-q'));

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var box = d.createElement('div');
        box.innerHTML = html;
        var items = box.querySelectorAll('.rel__i');
        var same = [], other = [];
        for (var i = 0; i < items.length; i++) {
          var el = items[i];
          if (el.getAttribute('data-id') === me) continue;
          var f = w.Garage.parseFit(el.getAttribute('data-car'));
          if (f.make !== self.make || f.model !== self.model) continue;
          if (self.gen && f.gen !== self.gen) continue;
          (f.part && f.part === self.part ? same : other).push(el);
        }
        var pick = other.concat(same).slice(0, 4);
        if (!pick.length) return;
        for (var j = 0; j < pick.length; j++) {
          var card = pick[j].querySelector('.card');
          if (card) grid.appendChild(card);
        }
        host.hidden = false;
        if (w.Garage.refresh) w.Garage.refresh();
      })
      .catch(function () { /* pa rrjet, seksioni mbetet i fshehur */ });
  }


  /* ---------- pyetja e dytë e Bacit ----------
     "A ki pjesë për Audi A6" i kthen të gjitha gjeneratat përnjëherë, dhe klienti
     s'e di cila është e tija. Prandaj, kur kërkesa e emërton modelin por jo vitin,
     Baci pyet edhe një herë: cili vit. Gjeneratat dalin nga katalogu (fitment.js),
     jo nga një listë e shkruar me dorë, prandaj nuk ofrojmë vite që s'i kemi.
     Nëse viti ose kodi janë dhënë tashmë, pyetja nuk shfaqet — mos e pyet dy herë. */
  function baciFollowup() {
    var box = d.querySelector('[data-baci-followup]');
    if (!box || !w.BAJRAMI_FIT) return;
    var said0 = '';
    try { said0 = new URL(w.location.href).searchParams.get('said') || ''; } catch (e0) {}
    var q = (said0 || box.getAttribute('data-q') || '').toLowerCase();
    if (!q) return;

    var hit = null;
    for (var brand in w.BAJRAMI_FIT) {
      var models = w.BAJRAMI_FIT[brand];
      for (var model in models) {
        var m = model.toLowerCase();
        if (q.indexOf(m) < 0) continue;
        if (!hit || m.length > hit.model.toLowerCase().length) {
          hit = { brand: brand, model: model, gens: models[model] };
        }
      }
    }
    if (!hit || hit.gens.length < 2) return;

    /* a e ka thënë tashmë gjeneratën ose vitin? */
    for (var i = 0; i < hit.gens.length; i++) {
      var g = (hit.gens[i].g || '').toLowerCase();
      if (g && q.indexOf(g) > -1) return;
    }
    /* Viti i shkruar në pyetje, pa regjistra të komplikuar: katër shifra që
       nisin me 19 ose 20. Mbahet i pari që gjendet. */
    var yn = 0;
    for (var yi = 0; yi + 4 <= q.length; yi++) {
      var chunk = q.substr(yi, 4);
      if (/^(19|20)[0-9][0-9]$/.test(chunk)) { yn = parseInt(chunk, 10); break; }
    }

    var list = hit.gens;
    if (yn) {
      var narrowed = list.filter(function (x) {
        return (!x.f || yn >= x.f) && (!x.t || yn <= x.t);
      });
      if (narrowed.length) list = narrowed;      /* viti e ngushton; e konfirmojmë me një çip */
    }

    var qEl = box.querySelector('[data-baci-q]');
    var chips = box.querySelector('[data-baci-chips]');
    var one = list.length === 1;
    qEl.textContent = box.getAttribute('data-ask') || (one
      ? 'Sipas vitit, ' + hit.model + ' i yt është kjo gjeneratë. E hap?'
      : "Për cilin vit është " + hit.model + "? Zgjedhe gjeneratën dhe t'i tregoj vetëm pjesët që i shkojnë.");
    for (var j = 0; j < list.length; j++) {
      var gen = list[j];
      var a = d.createElement('a');
      a.className = 'chip baci__chip';
      a.textContent = gen.l;
      a.href = '/search?type=product&q=' +
        encodeURIComponent(hit.model + (gen.g ? ' ' + gen.g : ''));
      chips.appendChild(a);
    }
    box.hidden = false;
  }


  /* ---------- pjesët e makinës së zgjedhur ----------
     Një burim i vetëm për të gjitha rafte: rezultatet e kërkimit për gjeneratën
     e zgjedhur, të marra një herë dhe të ndara mes rafteve. Çdo kartë e mbart
     identitetin e vet (marka|modeli|gjenerata|lloji), prandaj filtrimi bëhet me
     siguri e jo me hamendje. */
  var carCache = {};
  function carParts(q) {
    if (carCache[q]) return carCache[q];
    carCache[q] = fetch('/search?type=product&view=related&q=' + encodeURIComponent(q))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var box = d.createElement('div');
        box.innerHTML = html;
        return [].slice.call(box.querySelectorAll('.rel__i'));
      });
    return carCache[q];
  }
  function fitsCar(el, car) {
    var f = w.Garage.parseFit(el.getAttribute('data-car'));
    if (f.make !== car.make || f.model !== car.model) return false;
    if (car.gen && f.gen && f.gen !== car.gen) return false;
    return true;
  }

  /* Rafti i dedikuar: „Për makinën tënde" — çdo lloj pjese, i pari në faqe. */
  function myCarShelf() {
    var host = d.querySelector('[data-mycar-shelf]');
    if (!host || !w.Garage) return;
    var grid = host.querySelector('[data-mycar-grid]');
    var title = host.querySelector('[data-mycar-title]');
    var all = host.querySelector('[data-mycar-all]');
    var empty = host.querySelector('[data-mycar-empty]');
    var last = null;

    function fill() {
      var car = w.Garage.get(), q = w.Garage.query(car);
      if (!q) { host.hidden = true; last = null; return; }
      if (q === last) return;
      last = q;
      title.textContent = w.Garage.label(car);
      all.href = '/search?type=product&q=' + encodeURIComponent(q);
      grid.innerHTML = '';
      empty.hidden = true;
      host.hidden = false;
      carParts(q).then(function (items) {
        var n = 0;
        for (var i = 0; i < items.length && n < 8; i++) {
          if (!fitsCar(items[i], car)) continue;
          var card = items[i].querySelector('.card');
          if (card) { grid.appendChild(card.cloneNode(true)); n++; }
        }
        if (!n) empty.hidden = false;
        if (w.Garage.refresh) w.Garage.refresh();
      }).catch(function () { host.hidden = true; });
    }
    d.addEventListener('garage:change', fill);
    fill();
  }

  /* Raftet e koleksioneve: mbajnë llojet e pjesëve që i kanë tashmë, dhe i
     ndërrojnë produktet me ato të makinës së zgjedhur. Nëse për atë veturë
     s'kemi asnjë pjesë të atij lloji, rafti mbetet siç ishte — më mirë diçka
     e vërtetë e përgjithshme sesa një raft bosh. */
  function carShelves() {
    var hosts = d.querySelectorAll('[data-car-shelf]');
    if (!hosts.length || !w.Garage) return;
    for (var i = 0; i < hosts.length; i++) wire(hosts[i]);

    function wire(host) {
      var grid = host.querySelector('[data-shelf-grid]');
      var title = host.querySelector('[data-shelf-title]');
      var more = host.querySelector('[data-shelf-more]');
      if (!grid) return;
      var original = grid.innerHTML;
      var genericTitle = title ? (title.getAttribute('data-generic') || title.textContent) : '';
      var genericHref = more ? more.getAttribute('href') : '';
      var parts = {};
      var cards = grid.querySelectorAll('.card[data-car]');
      for (var j = 0; j < cards.length; j++) {
        var pt = w.Garage.parseFit(cards[j].getAttribute('data-car')).part;
        if (pt) parts[pt] = true;
      }
      var anyPart = Object.keys(parts).length === 0;
      var last = null;

      function fill() {
        var car = w.Garage.get(), q = w.Garage.query(car);
        if (!q) {
          if (last !== null) {
            grid.innerHTML = original;
            if (title) title.textContent = genericTitle;
            if (more) more.setAttribute('href', genericHref);
            if (w.Garage.refresh) w.Garage.refresh();
          }
          last = null;
          return;
        }
        if (q === last) return;
        last = q;
        carParts(q).then(function (items) {
          var keep = [];
          for (var k = 0; k < items.length; k++) {
            if (!fitsCar(items[k], car)) continue;
            var f = w.Garage.parseFit(items[k].getAttribute('data-car'));
            if (!anyPart && !parts[f.part]) continue;
            keep.push(items[k]);
            if (keep.length >= 8) break;
          }
          if (!keep.length) return;          /* s'ka çka të tregojmë — lëre siç ishte */
          grid.innerHTML = '';
          for (var m = 0; m < keep.length; m++) {
            var card = keep[m].querySelector('.card');
            if (card) grid.appendChild(card.cloneNode(true));
          }
          if (title) title.textContent = genericTitle + ' — ' + w.Garage.label(car);
          if (more) more.setAttribute('href', '/search?type=product&q=' + encodeURIComponent(q));
          if (w.Garage.refresh) w.Garage.refresh();
        }).catch(function () {});
      }
      d.addEventListener('garage:change', fill);
      fill();
    }
  }


  /* ---------- nga 0 në 400 ----------
     Makina niset nga e majta dhe merr shpejtësi për 9.99 sekonda: numëruesi,
     shiriti dhe vijat e shpejtësisë shkojnë bashkë me të. Përshpejtimi nuk është
     linear — të parat 200 vijnë shumë më shpejt se të fundit 100. */
  function drive() {
    var host = d.querySelector('[data-drive]');
    if (!host) return;
    var TOP  = parseInt(host.getAttribute('data-top'), 10) || 400;
    var SECS = parseFloat(host.getAttribute('data-secs')) || 9.99;
    var car  = host.querySelector('[data-drive-car]');
    var str  = host.querySelector('[data-drive-streaks]');
    var kmh  = host.querySelector('[data-drive-kmh]');
    var tim  = host.querySelector('[data-drive-time]');
    var fill = host.querySelector('[data-drive-fill]');
    var ticks = host.querySelector('[data-drive-ticks]');
    if (!car) return;

    if (ticks && !ticks.children.length) {
      var step = TOP > 300 ? 100 : 50;
      for (var v = 0; v <= TOP; v += step) {
        var sp = d.createElement('span');
        sp.textContent = v;
        ticks.appendChild(sp);
      }
    }

    var still = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function draw(p, t) {
      var v = TOP * (1 - Math.pow(1 - p, 2.4));
      car.style.transform = 'translateX(' + (24 * p).toFixed(2) + '%)';
      if (str) str.style.opacity = (0.34 * Math.pow(p, 1.5)).toFixed(3);
      if (fill) fill.style.width = ((v / TOP) * 100).toFixed(2) + '%';
      kmh.textContent = Math.round(v);
      tim.textContent = t.toFixed(2) + ' s';
    }

    var running = false;
    function run() {
      if (running) return;
      if (still) { draw(1, SECS); return; }
      running = true;
      var t0 = null;
      (function frame(ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min((ts - t0) / 1000, SECS);
        draw(t / SECS, t);
        if (t < SECS) requestAnimationFrame(frame);
        else { draw(1, SECS); running = false; }
      })(performance.now());
    }

    draw(0, 0);
    var again = host.querySelector('[data-drive-again]');
    if (again) again.addEventListener('click', function () { running = false; draw(0, 0); run(); });

    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) { run(); io.disconnect(); }
        }
      }, { threshold: 0.3 });
      io.observe(host);
    } else { run(); }
  }

  /* ---------- ngushtimi i rezultateve ----------
     Kërkimi i Shopify-t i ndan fjalët: "Q7" përputhet edhe me Golf 7 edhe me X7,
     sepse të dyja e kanë shifrën 7. Klienti nuk pyeti për ato. Prandaj i mbajmë
     vetëm kartat që e mbajnë identitetin e kërkuar. Asgjë nuk fshihet përgjithmonë:
     një klikim i kthen të gjitha. Dhe nëse klienti ka shkruar fjali, e tregojmë
     hapur se çka kuptuam prej saj. */
  function searchFocus() {
    var grid = d.querySelector('[data-search-grid]');
    var box = d.querySelector('[data-baci-followup]');
    if (!grid || !box || !w.BAJRAMI_FIT || !w.Garage) return;
    var q = box.getAttribute('data-q') || '';
    var said = '';
    try { said = new URL(w.location.href).searchParams.get('said') || ''; } catch (e) {}

    var c = readCar(said || q);
    if (c.universal || !c.model) return;
    var gens = w.BAJRAMI_FIT[c.brand][c.model] || [];
    var gen = c.gen;

    /* Vetëm viti pa kod: mbajmë gjeneratat që e mbulojnë atë vit. Nëse mbetet
       një e vetme, ajo është; nëse mbeten dy (p.sh. 2017 bie mes Golf 7 dhe 7.5),
       nuk zgjedhim ne — por as nuk i tregojmë Golf 8 e Golf 6. */
    var allow = null;
    if (!gen && c.year) {
      var fits = [];
      for (var i = 0; i < gens.length; i++) {
        var g = gens[i];
        if ((!g.f || c.year >= g.f) && (!g.t || c.year <= g.t)) fits.push(g.g);
      }
      if (fits.length === 1) gen = fits[0];
      else if (fits.length > 1) allow = fits;
    }
    if (gen) allow = [gen];

    /* Vitet e gjeneratës së zgjedhur — për pjesët që kodin nuk e kanë në titull. */
    var gf = 0, gt = 0;
    for (var gi2 = 0; gi2 < gens.length; gi2++) {
      if (gens[gi2].g === gen) { gf = gens[gi2].f || 0; gt = gens[gi2].t || 0; break; }
    }

    var cards = grid.querySelectorAll('.card[data-car]');
    if (!cards.length) return;
    var hidden = 0, shown = 0;
    for (var j = 0; j < cards.length; j++) {
      var f = w.Garage.parseFit(cards[j].getAttribute('data-car'));
      var ok = f.model === c.model;
      if (ok && allow && f.gen && allow.indexOf(f.gen) < 0) ok = false;
      /* Pa kod në titull, gjenerata vendoset nga vitet: nëse rangjet nuk preken,
         pjesa nuk është për atë veturë — edhe pse modeli përputhet. */
      if (ok && gen && !f.gen && gf && f.from) {
        var pTo = f.to || 9999, gTo = gt || 9999;
        /* Kufijtë janë ekskluzivë: një pjesë (2019–2023) nuk i takon gjeneratës
           2015–2019 vetëm sepse preken te viti 2019 — aty ndërrohet gjenerata. */
        if (!(f.from < gTo && gf < pTo)) ok = false;
      }
      cards[j].hidden = !ok;
      if (ok) shown++; else hidden++;
    }
    if (!hidden || !shown) {
      for (var k = 0; k < cards.length; k++) cards[k].hidden = false;
      if (!shown && said) showNote(c, gen, null, said);
      return;
    }
    showNote(c, gen, { shown: shown, cards: cards }, said);

    function showNote(car, g2, res, saidText) {
      var note = d.querySelector('[data-search-note]');
      if (!note) return;
      var txt = note.querySelector('[data-search-note-text]');
      var cnt = d.querySelector('[data-search-count]');
      var label = car.model;
      if (g2) label = g2.indexOf(car.model) === 0 ? g2 : car.model + ' ' + g2;
      var full = label + (car.part ? ' · ' + car.part : '');
      var line = '';
      if (saidText) line = 'Ke shkruar: ' + saidText + '. Po kërkoj: ' + full + '.';
      else line = 'Po shfaq vetëm pjesët për ' + full + '.';
      if (txt) txt.textContent = line;
      note.hidden = false;
      if (!res) return;
      var total = cnt ? cnt.textContent : '';
      if (cnt) cnt.textContent = res.shown + ' rezultate për ' + label;
      var all = d.querySelector('[data-search-all]');
      if (all) all.addEventListener('click', function () {
        for (var n = 0; n < res.cards.length; n++) res.cards[n].hidden = false;
        note.hidden = true;
        if (cnt) cnt.textContent = total;
      });
    }
  }

  /* ---------- "kete nuk e shesim" ----------
     Kur klienti pyet per dicka qe nuk e mbajme, rezultatet poshte jane pjeset e
     vetures se tij — te dobishme, por lehte lexohen si "po, e kemi". Prandaj mbi to
     rri nje rresht qe e thote qarte se cka nuk kemi. */
  function missNote() {
    var el = d.querySelector('[data-miss]'); if (!el) return;
    var nope = '', said = '';
    try {
      var sp = new URL(w.location.href).searchParams;
      nope = sp.get('nope') || ''; said = sp.get('said') || '';
    } catch (e) { return; }
    if (!nope) return;
    var c = readCar(said);
    var car = c.model ? (c.gen && c.gen.indexOf(c.model) !== 0 ? c.model + ' ' + c.gen : (c.gen || c.model)) : '';
    var txt = el.querySelector('[data-miss-t]');
    if (txt) {
      txt.textContent = nope + ' nuk i shesim — mbajmë pjesë karocerie, ndriçim dhe mirëmbajtje.' +
        (car ? ' Ja çka kemi për ' + car + ':' : '');
    }
    el.hidden = false;
  }

  function boot() { heroVideo(); gallery(); variants(); paint(); baci(); facets(); fitOnly(); quickAdd(); related(); baciFollowup(); myCarShelf(); carShelves(); garageConfirm(); drive(); searchFocus(); missNote(); }
  if (d.readyState !== 'loading') boot(); else d.addEventListener('DOMContentLoaded', boot);
})(window, document);